export default {
  sortFeeds: (feeds) => {
    return feeds.sort((a, b) => {
      let first = a.username.toLowerCase(), second = b.username.toLowerCase();
      if (first < second){
        return -1;
      }

      if (first > second) {
        return 1;
      }

      return 0;
    });
  },
};
